import { useUiTranslator } from "../../../../hooks/useUiTranslator";
import { useGetApiEasyCountry } from "../../../../openapi/backendApi";
import { exportQuoteToExcel } from "../../tools/helper";

import { JSX } from "react";

import { useLanguage } from "@4pace-cpq/core";
import Button from "@mui/material/Button";
import {
  useConfigurationApi,
  useSessionId,
} from "@plansoft-configuration-renderer/framework";

export function DownloadUserManualButton(): JSX.Element {
  const api = useConfigurationApi();
  const sessionId = useSessionId();
  const { selectedLanguage } = useLanguage();
  const t = useUiTranslator();

  const { data: countryData } = useGetApiEasyCountry();
  const country = countryData?.data.string;

  const language = selectedLanguage?.languageCode?.split("-")[0];

  async function fetchUserManual(): Promise<string> {
    const res = await api.invokeUserDefinedGetter({
      id: sessionId,
      name: "getMarketingCategory",
      invokeUserDefinedGetterParams: {
        path: "/XAS_PRODUCT_VIEW/0/",
        input: JSON.stringify({}),
      },
    });
    if (res?.output) {
      return res?.output;
    }
    return "";
  }

  async function handleDownload(): Promise<void> {
    const materialNumber = await fetchUserManual();
    exportQuoteToExcel(
      materialNumber,
      typeof country === "string" ? country : "AT",
      language ?? "EN",
      t,
    );
  }

  return (
    <Button onClick={handleDownload} variant="contained">
      {t("CustomApp:buttons.downloadUserManual", "User Manual")}
    </Button>
  );
}
